module.exports = ".visio-bottom-icon {\n  width: 12%;\n}\n\n.visio-bottom{\n  position: absolute;\n  bottom:5%;\n  z-index: 2;\n  width: 100vw;\n}\n\n.photoHQ{\n  float: right;\n  margin-right: -53.5%;\n  width: 11%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visio/publisher/publisher.component.css
// module id = ./src/app/visio/publisher/publisher.component.css
// module chunks = main